import jsPDF from 'jspdf';
import _ from 'assets/images/storage_fee.png';
import { filesToBase64 } from 'utils';

const languageFonts = {
  zh: {
    fontFamily: 'NotoSansSC',
    fontStyle: 'normal',
    url: '/p/images/provider/fonts/Almarai-Regular.ttf',
    
  },
  ar: {
    fontFamily: 'Almarai-Regular',
    fontStyle: 'normal',
    url: '/p/images/provider/fonts/Almarai-Regular.ttf',
  },
  ko: {
    fontFamily: 'NanumGothic-Regular',
    fontStyle: 'normal',
    url: '/p/images/provider/fonts/NanumGothic-Regular.ttf',
  },
  bn: {
    fontFamily: 'NotoSansBengali',
    fontStyle: 'normal',
    url: '/p/images/provider/fonts/NotoSansBengali[wdth,wght].ttf',
  },
  ja: {
    fontFamily: 'NotoSansSC',
    fontStyle: 'normal',
    url: '/p/images/provider/fonts/NotoSansSC.ttf',
  },
  default: {
    fontFamily: 'NotoSans-Regular',
    fontStyle: 'normal',
    url: '/p/images/provider/fonts/NotoSans-Regular.ttf',
  },
};

const url = `${window.location.origin}${process.env.NODE_ENV == 'development' ? '' : process.env.REACT_APP_PUBLIC_URL}`;

export const generateAuthPdf = async (
  { address, subTitle, formInput, patientName, submittedOn, signature, paragraph1, lang },
  callback,
) => {
  var lMargin = 14; //left margin in mm
  var rMargin = 15; //right margin in mm
  var tMargin = 19; //right margin in mm
  var pdfInMM = 210; // width of A4 in mm
  const doc = new jsPDF('p', 'mm', 'a4');
  const { url, fontFamily, fontStyle } = languageFonts[lang] || languageFonts['default'];
  doc.addFont(url, fontFamily, fontStyle);

  doc.setFont(
    languageFonts[lang]?.fontFamily || languageFonts['default']?.fontFamily,
    languageFonts['default'].fontStyle,
  );
  doc.viewerPreferences({ FitWindow: true }, true);
  /** Border */
  let x1 = 12,
    x2 = 198,
    y1 = 10,
    y2 = 260;

  doc.setDrawColor(192, 192, 192);
  doc.line(x1, y1, x2, y1);
  doc.line(x2, y1, x2, y2);
  doc.line(x2, y2, x1, y2);
  doc.line(x1, y2, x1, y1);

  /** Address */
  doc.setFontSize(11);
  doc.setTextColor(0, 0, 0);
  doc.setLineHeightFactor(1.3);
  doc.text(address, lMargin, tMargin);
  tMargin += 25;
  /** End */

  /** Sub Title */
  doc.setFontSize(12.3);
  doc.setTextColor(0, 0, 0);
  doc.text(subTitle, lMargin, tMargin);
  tMargin += 9;
  /** End */

  /** Paragraph 1 */
  doc.setFontSize(10.9);
  var lines1 = doc.splitTextToSize(paragraph1, pdfInMM - lMargin - rMargin);
  doc.text(lines1, lMargin, tMargin, {
    maxWidth: 181,
    align: 'justify',
  });
  tMargin += 110;
  /** End */

  /** Form Fields */
  tMargin += 25;
  doc.setFontSize(12);

  const ROW_HEIGHT = 24;

  formInput.forEach((item, i) => {
    const leftMargin = lMargin + (i % 2 === 1 ? 90 : 0);
    const topMargin = tMargin + Math.floor(i / 2) * ROW_HEIGHT;

    doc.text(item.value || '', leftMargin, topMargin);
    doc.text('________________________________', leftMargin, topMargin + 5);
    doc.text(item.label, leftMargin, topMargin + 12);
  });
  
  tMargin += Math.ceil(formInput.length / 2) * ROW_HEIGHT - 15;
  /** End */

  /** Signature */
  let base64 = await filesToBase64([signature?.signature ? signature.signature : signature]);
  if (base64) {
    let leftMargin = lMargin;
    doc.addImage(base64, 'PNG', leftMargin, tMargin + 7, 60, 10);
    tMargin += 19;
    doc.text('________________________________', leftMargin, tMargin);
    tMargin += 5;
    doc.text(signature?.label, leftMargin, tMargin);
  }
  /** End */

  /** Patient & Submitted Time */
  if (patientName) {
    doc.text(`${patientName?.label}: ${patientName?.patient}`, lMargin + 90, tMargin);
    tMargin += 5;
  }
  if (submittedOn) {
    doc.text(`Request Submitted on: ${submittedOn}`, lMargin + 90, tMargin);
    tMargin += 5;
  }
  /** End */

  /** Generate PDF Data */
  let blobPDF = new Blob([doc.output('blob')], { type: 'application/pdf', name: 'Patient_eAuth.pdf' });
  let blobURL = URL.createObjectURL(blobPDF);

  /** Callback Function */
  callback && callback({ blobPDF, blobURL });
  /** Return Data */
  return { blobPDF, blobURL };
};

export const generateSubscriptionBill = async (
  { title = '', patientName = '', invoiceDate = '', submittedOn = '', billTo = [''], services = [], description = [] },
  callback,
) => {
  const logoURL = '/p/images/provider/logo.png';
  const mainAddress = [
    'ChartRequest',
    'One Glenlake Parkway, Suite 650',
    'Atlanta, GA 30328',
    '(888) 895-8366',
    'support@chartrequest.com',
    'TAX ID: 46-4228040 | MyHealth, LLC',
  ];

  var lMargin = 15; //left margin in mm
  var tMargin = 16; //right margin in mm
  const doc = new jsPDF('p', 'mm', 'a4');
  doc.viewerPreferences({ FitWindow: true }, true);
  /** Border */
  let x1 = 12,
    x2 = 198,
    y1 = 10,
    y2 = 260;
  doc.setDrawColor(192, 192, 192);
  doc.line(x1, y1, x2, y1);
  doc.line(x2, y1, x2, y2);
  doc.line(x2, y2, x1, y2);
  doc.line(x1, y2, x1, y1);

  /** Logo */
  doc.addImage(logoURL, 'PNG', lMargin, tMargin, 90, 18);
  tMargin += 30;

  /** Title */
  doc.setFontSize(18);
  doc.setFont('helvetica', 'bold');
  doc.setTextColor(0, 0, 0);
  doc.text(title, lMargin, tMargin);
  tMargin += 9;
  /** End */

  /** Adress */
  doc.setFont('helvetica', 'normal');
  doc.setFontSize(11);
  doc.setLineHeightFactor(1.3);
  doc.text(mainAddress, lMargin, tMargin);
  /** End */

  /** Patient Info */
  doc.setFont('helvetica', 'bold');
  doc.text(`Patient: ${patientName}`, lMargin + 120, tMargin - 1);
  tMargin += 5;
  doc.setFont('helvetica', 'normal');
  doc.text(`Invoice Date: ${invoiceDate}`, lMargin + 120, tMargin - 1);
  tMargin += 5;
  doc.text(`Submitted On: ${submittedOn}`, lMargin + 120, tMargin - 1);
  tMargin += 35;
  /** End */

  /** Bill To */
  doc.setFontSize(14);
  doc.text('BILL TO:', lMargin, tMargin);
  tMargin += 1;
  doc.line(lMargin, tMargin, lMargin + 50, tMargin);
  tMargin += 10;
  doc.setFontSize(11);
  doc.setLineHeightFactor(1.3);
  doc.text(billTo, lMargin, tMargin);
  tMargin += 30;
  /** End */

  /** Services */
  doc.setFontSize(14);
  doc.text('Services:', lMargin, tMargin);
  tMargin += 1;
  doc.line(lMargin, tMargin, lMargin + 180, tMargin);
  tMargin += 10;
  doc.setFontSize(11);
  services.forEach(({ name, amount, fontWeight }) => {
    doc.setFont('helvetica', fontWeight === 'bold' ? 'bold' : 'normal');
    doc.text(name, lMargin, tMargin);
    doc.text(amount, lMargin + 180, tMargin, 'right');
    tMargin += 5;
  });
  /** End */

  /** Description */
  if (description.length) {
    tMargin += 10;
    doc.setFont('helvetica', 'normal');
    doc.setFontSize(12);
    doc.setLineHeightFactor(1.3);
    doc.text(description, lMargin, tMargin);
  }

  /** Generate PDF Data */
  let blobPDF = new Blob([doc.output('blob')], { type: 'application/pdf', name: 'Patient_eAuth.pdf' });
  let blobURL = URL.createObjectURL(blobPDF);

  /** Test Function */
  let a = document.createElement('a');
  a.href = blobURL;
  a.target = '_blank';
  a.click();

  /** Callback Function */
  callback && callback({ blobPDF, blobURL });

  /** Return Data */
  return { blobPDF, blobURL };
};

export const generateSubscriptionAgreement = ({ title = '', initials = '', date = '', card = '', amount = '' }) => {
  const logoURL = '/p/images/provider/logo.png';
  const storageImage = '/p/images/provider/storage_fee.png';
  const description = [
    'ChartRequest provides seamless online access to your medical records. After 30 days of',
    'records availability, we archive them into our embedded data vault. If you would like to',
    `securely access your medical records at any time after 30 days, we offer a ${amount} per`,
    'month unlimited sharing subscription.',
  ];
  const sign = [
    `By adding my initials here, I agree to the ${amount} monthly subscription to`,
    `store and share my records. Please submit monthly auto-payments to the`,
    `following card:`,
  ];

  var lMargin = 15; //left margin in mm
  var tMargin = 16; //right margin in mm
  const doc = new jsPDF('p', 'mm', 'a4');
  doc.viewerPreferences({ FitWindow: true }, true);
  /** Border */
  let x1 = 12,
    x2 = 198,
    y1 = 10,
    y2 = 260;
  doc.setDrawColor(192, 192, 192);
  doc.line(x1, y1, x2, y1);
  doc.line(x2, y1, x2, y2);
  doc.line(x2, y2, x1, y2);
  doc.line(x1, y2, x1, y1);

  /** Logo */
  doc.addImage(logoURL, 'PNG', lMargin, tMargin, 90, 18);
  tMargin += 40;

  /** Title */
  doc.setFontSize(18);
  doc.setFont('helvetica', 'bold');
  doc.setTextColor(0, 0, 0);
  doc.text(title, lMargin, tMargin);
  tMargin += 15;
  /** End */

  /** Storage Fee */
  doc.addImage(storageImage, 'PNG', lMargin, tMargin, 170, 40, 'center');
  tMargin += 60;

  /** Description */
  doc.setFont('helvetica', 'normal');
  doc.setFontSize(12);
  doc.setLineHeightFactor(1.3);
  doc.text(description, lMargin, tMargin);
  tMargin += 40;

  /** Sign */
  doc.setFillColor(212, 212, 212);
  doc.rect(lMargin, tMargin - 5, lMargin + 130, 20, 'F');

  doc.setFontSize(11);
  // doc.setFillColor('#ff0000');
  doc.setLineHeightFactor(1.3);
  doc.text(sign, lMargin + 3, tMargin);
  tMargin += 30;

  /** Form data */
  doc.setFontSize(12);
  doc.text(`Initials: ${initials}`, lMargin, tMargin);
  tMargin += 10;
  doc.text(`Date/Time: ${date}`, lMargin, tMargin);
  tMargin += 10;
  doc.text(`Monthly payments will be made to ${card}`, lMargin, tMargin);

  /** Generate PDF Data */
  let blobPDF = new Blob([doc.output('blob')], { type: 'application/pdf', name: 'Patient_eAuth.pdf' });
  let blobURL = URL.createObjectURL(blobPDF);

  /** Test Function */
  let a = document.createElement('a');
  a.href = blobURL;
  a.target = '_blank';
  a.click();
};